import { useTranslation } from 'react-i18next';

export default function Comparison() {
  const { t } = useTranslation();

  const rows = [
    {
      method: t('compare.row1_col1'),
      time: t('compare.row1_col2'),
      comfort: t('compare.row1_col3'),
      risk: t('compare.row1_col4'),
    },
    {
      method: t('compare.row2_col1'),
      time: t('compare.row2_col2'),
      comfort: t('compare.row2_col3'),
      risk: t('compare.row2_col4'),
    },
    {
      method: t('compare.row3_col1'),
      time: t('compare.row3_col2'),
      comfort: t('compare.row3_col3'),
      risk: t('compare.row3_col4'),
      highlight: true,
    },
  ];

  return (
    <section className="w-full py-16 md:py-24 bg-background-50">
      <div className="px-4 md:px-6 lg:px-10 max-w-[900px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900">
            {t('compare.title')}
          </h2>
        </div>

        <div className="rounded-2xl border border-background-200/70 overflow-hidden overflow-x-auto">
          <div className="grid grid-cols-4 bg-background-100 border-b border-background-200/70 min-w-[540px]">
            {[t('compare.col1'), t('compare.col2'), t('compare.col3'), t('compare.col4')].map((col) => (
              <div key={col} className="px-4 md:px-6 py-3.5 text-xs font-semibold text-foreground-500 uppercase tracking-wider">
                {col}
              </div>
            ))}
          </div>
          {rows.map((row) => (
            <div
              key={row.method}
              className={`grid grid-cols-4 border-b border-background-200/60 last:border-0 transition-colors min-w-[540px] ${row.highlight ? 'bg-primary-50/70' : 'hover:bg-background-50'}`}
            >
              <div className="px-4 md:px-6 py-4 text-sm font-medium text-foreground-900">{row.method}</div>
              <div className="px-4 md:px-6 py-4 text-sm text-foreground-700">{row.time}</div>
              <div className="px-4 md:px-6 py-4 text-sm text-foreground-700">{row.comfort}</div>
              <div className="px-4 md:px-6 py-4 text-sm text-foreground-700">{row.risk}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}